import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
const REDUCER_NAME = 'clientAllowances';
import { stopSubmit } from 'redux-form';
import { newItemFailure } from 'src/reducers/common/itemReducer';
import { setExtras } from 'src/reducers/common/listReducer';

const areMotivationMonthsValid = (months) => {
  if (months?.length === 1) {
    if (!months[0].toMonth && !months[0].bonusAmount) {
      throw new Error('Adding an item for PROBATION also requires setting an item for FULLTIME');
    }
  }
  return undefined;
};

const findDuplicateMonths = (table) => {
  const duplicateMonths = {};
  for (let i = 0; i < table.length; i++) {
    const { toMonth, fromMonth } = table[i];
    const key = `${fromMonth}-${toMonth}`;
    if (duplicateMonths[key]) {
      duplicateMonths[key].push(i);
    } else {
      duplicateMonths[key] = [i];
    }
  }

  const result = Object.keys(duplicateMonths)
    .map((key) => {
      if (duplicateMonths[key].length > 1) {
        return { [key]: duplicateMonths[key] };
      }
    })
    .filter((item) => item !== undefined);
  return result ?? false;
};

const areMonthsOrderedCorrectly = (months) => {
  if (!Array.isArray(months) || months.length < 1) {
    throw new Error('Invalid months data');
  }

  for (let i = 0; i < months.length - 1; i++) {
    const currentToMonth = parseInt(months[i].toMonth);
    const currentFromMonth = parseInt(months[i].fromMonth);
    const nextFromMonth = parseInt(months[i + 1].fromMonth - 1);

    if (currentToMonth !== nextFromMonth || currentFromMonth > currentToMonth || currentToMonth < currentFromMonth) {
      throw new Error('Months are not ordered correctly');
    }
  }

  return undefined;
};

const checkEachMonthHaveBonusAmount = (months) => {
  if (!Array.isArray(months) || months.length < 1) throw new Error('Invalid months data');

  months.map((month) => {
    const { bonusAmount } = month;
    if (Number.isNaN(bonusAmount) || !bonusAmount) throw new Error('Bonus amount should be a number');
  });

  return undefined;
};

const areMonthEmpty = (months) => {
  if (!Array.isArray(months) || months.length < 1) throw new Error('Invalid months data');

  months.forEach((month) => {
    const { toMonth, fromMonth } = month;
    const matchToMonth = toMonth?.toString().match(/[a-zA-Zก-ฮ]/gi);
    const matchFromMonth = fromMonth?.toString().match(/[a-zA-Zก-ฮ]/gi);

    if (matchToMonth?.length > 0 || matchFromMonth?.length > 0) {
      throw new Error('Invalid month');
    }
  });

  months.forEach((month) => {
    const { toMonth, fromMonth } = month;
    if (!fromMonth || !toMonth) {
      throw new Error('Invalid month');
    }
  });
};
const validateMotivationMonths = (months) => {
  try {
    areMotivationMonthsValid(months);
    areMonthEmpty(months);

    const checkNoDuplicationMonths = findDuplicateMonths(months);
    if (checkNoDuplicationMonths.length > 0) {
      const errorMessages = checkNoDuplicationMonths.map((object) => {
        const key = Object.keys(object).join('');
        const values = [].concat(...Object.values(object)).map((value) => value + 1);
        return `Months worked value is duplicate ${key} in step ${values.join(',')}`;
      });
      return {
        error: errorMessages,
        data: checkNoDuplicationMonths,
      };
    }
    areMonthsOrderedCorrectly(months);
    checkEachMonthHaveBonusAmount(months);

    return months;
  } catch (err) {
    throw new Error(err.message);
  }
};

const getErrors = (errors) => {
  if (!Array.isArray(errors) || errors.length < 1) return undefined;
  const getRowErrors = errors.flatMap((err) => Object.values(err)).flat();
  return getRowErrors;
};

const getClientAllowanceFormat = (data, isMotivation) => (dispatch) => {
  if (!data) return undefined;

  const allowanceOptions = {
    allowanceAmountType: 'motivation',
    allowanceAmount: 0,
  };

  const clientMotivation = {
    motivationType: data.motivationType,
    motivationStep: JSON.stringify(data.motivationStep),
    probationStep: JSON.stringify(data.probationStep),
    clientAllowanceItemIds: data.clientAllowanceItemIds,
    effective_payment_month_id: data.employeePaymentMonthId
  };
 
  let isMotivationValid = null;

  if (isMotivation) {
    isMotivationValid = validateMotivationMonths(data.motivationStep);
  }

  if (isMotivationValid && isMotivationValid.error) {
    dispatch(stopSubmit(CLIENT_ALLOWANCE_FORM));
    dispatch(newItemFailure(REDUCER_NAME, isMotivationValid.error));
    if (isMotivationValid.data) {
      dispatch(setExtras(REDUCER_NAME, { errorTables: [...isMotivationValid.data] }));
    }
    return;
  }

  return isMotivation
    ? {
        client_allowance: { ...data, ...allowanceOptions },
        client_motivation: clientMotivation,
        client_base_salary_client_allowance: { client_allowance_item_id: data.clientAllowanceItemId },
      }
    : {
        client_allowance: { ...data },
        client_base_salary_client_allowance: { client_allowance_item_id: data.clientAllowanceItemId },
      };
};

export {
  validateMotivationMonths,
  areMonthsOrderedCorrectly,
  checkEachMonthHaveBonusAmount,
  findDuplicateMonths,
  areMonthEmpty,
  getErrors,
  getClientAllowanceFormat,
};
